module.exports = __webpack_public_path__ + "static/media/contactShape.c3fa98dc.png";